import { render, staticRenderFns } from "./WhoWeAreSection.vue?vue&type=template&id=ffcc1dc8"
import script from "./WhoWeAreSection.vue?vue&type=script&lang=js"
export * from "./WhoWeAreSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports